import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  href?: string;
  className?: string;
  external?: boolean;
  onClick?: () => void;
};
export function CtaButton({
  children,
  size = 'md',
  href = '#comprar',
  className = '',
  external = false,
  onClick
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-5 text-[13px] sm:text-sm tracking-[0.14em]' : 'px-7 py-4 text-[12px] sm:text-[13px] tracking-[0.14em]';
  return <a href={href} onClick={onClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex w-full items-center justify-center gap-3 rounded-full bg-caribe font-sans font-medium uppercase text-white shadow-[0_10px_30px_-12px_rgba(43,191,184,0.7)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#25a8a2] active:scale-[0.985] sm:w-auto ${sizeClasses} ${className}`} data-id="element-176" data-mp="1qvuqt7qfi292">
      <span className="text-center leading-tight" data-id="element-177" data-mp="187prqdkpv5gl">{children}</span>
      <span aria-hidden="true" className="hidden shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 sm:inline" data-id="element-178" data-mp="2hfruzavmsm77">
        &rarr;
      </span>
    </a>;
}